(function (root, factory) {
  var api = factory(root || {});
  if (root) {
    root.ParadisePostersNewArrivalsBadge = api;
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
})(typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : this, function (window) {
  'use strict';

  var COLLECTION_HANDLE = 'new-arrivals';
  var STORAGE_KEY = 'paradise-posters:new-arrivals:last-seen-published-at';
  var DISPLAY_CAP = 10;
  var DATA_SCRIPT_ID = 'NewArrivalsBadgeData';
  var BADGE_SELECTOR = '[data-new-arrivals-count]';
  var TEST_COUNT_PARAM = 'pp_new_arrivals_badge';
  var state = {
    count: 0,
    loaded: false
  };
  var observerStarted = false;

  function supportsStorage() {
    try {
      if (!window.localStorage) {
        return false;
      }
      var testKey = '__pp_new_arrivals_test__';
      window.localStorage.setItem(testKey, '1');
      window.localStorage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  function shouldTrackUrl(pathname) {
    return /\/collections\/new-arrivals(?:$|[\/?#])/.test(pathname || '');
  }

  function isCollectionPage() {
    if (!window.location || !window.location.pathname) {
      return false;
    }
    return shouldTrackUrl(window.location.pathname);
  }

  function readLastSeen() {
    if (!supportsStorage()) {
      return '';
    }
    try {
      return window.localStorage.getItem(STORAGE_KEY) || '';
    } catch (error) {
      return '';
    }
  }

  function writeLastSeen(value) {
    if (!value || !supportsStorage()) {
      return;
    }
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (error) {}
  }

  function formatBadgeCount(count) {
    if (count > DISPLAY_CAP) {
      return DISPLAY_CAP + '+';
    }
    return String(count);
  }

  function getForcedCount() {
    if (!window.location || !window.location.search || !window.URLSearchParams) {
      return null;
    }
    var params = new window.URLSearchParams(window.location.search);
    var raw = params.get(TEST_COUNT_PARAM);
    if (raw === null || raw === '') {
      return null;
    }
    var value = parseInt(raw, 10);
    if (isNaN(value) || value < 0) {
      return null;
    }
    return value;
  }

  function renderCount(count) {
    var badges = document.querySelectorAll(BADGE_SELECTOR);
    badges.forEach(function (badge) {
      if (count > 0) {
        badge.textContent = formatBadgeCount(count);
        badge.removeAttribute('hidden');
      } else {
        badge.textContent = '0';
        badge.setAttribute('hidden', 'hidden');
      }
    });
  }

  function parsePublishedAt(product) {
    if (!product || !product.published_at) {
      return NaN;
    }
    return Date.parse(product.published_at);
  }

  function getLatestPublishedAt(products) {
    var latestProduct = null;
    var latestTime = NaN;

    products.forEach(function (product) {
      var publishedAt = parsePublishedAt(product);
      if (isNaN(publishedAt)) {
        return;
      }
      if (latestProduct === null || publishedAt > latestTime) {
        latestProduct = product;
        latestTime = publishedAt;
      }
    });

    return latestProduct && latestProduct.published_at ? latestProduct.published_at : '';
  }

  function getUnseenCount(products, lastSeen) {
    if (!lastSeen) {
      return products.length;
    }

    var lastSeenTime = Date.parse(lastSeen);
    if (isNaN(lastSeenTime)) {
      return products.length;
    }

    return products.reduce(function (count, product) {
      var publishedAt = parsePublishedAt(product);
      if (isNaN(publishedAt)) {
        return count;
      }
      return publishedAt > lastSeenTime ? count + 1 : count;
    }, 0);
  }

  function applyProducts(products) {
    var latestPublishedAt = getLatestPublishedAt(products);
    var count = getUnseenCount(products, readLastSeen());

    if (isCollectionPage()) {
      if (latestPublishedAt) {
        writeLastSeen(latestPublishedAt);
      }
      count = 0;
    }

    state.count = count;
    state.loaded = true;
    renderCount(count);
  }

  function refreshBadges() {
    if (!state.loaded) {
      return;
    }
    renderCount(state.count);
  }

  function nodeContainsBadge(node) {
    if (!node || node.nodeType !== 1) {
      return false;
    }
    if (node.matches && node.matches(BADGE_SELECTOR)) {
      return true;
    }
    return Boolean(node.querySelector && node.querySelector(BADGE_SELECTOR));
  }

  function observeBadgeMounts() {
    if (observerStarted || !window.MutationObserver || !window.document || !document.body) {
      return;
    }

    observerStarted = true;
    var observer = new window.MutationObserver(function (mutations) {
      var hasNewBadge = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes || []).some(nodeContainsBadge);
      });

      if (hasNewBadge) {
        refreshBadges();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function readEmbeddedProducts() {
    if (!window.document) {
      return [];
    }

    var script = document.getElementById(DATA_SCRIPT_ID);
    if (!script) {
      return [];
    }

    try {
      var payload = JSON.parse(script.textContent || '{}');
      return payload && Array.isArray(payload.products) ? payload.products : [];
    } catch (error) {
      return [];
    }
  }

  function init() {
    observeBadgeMounts();

    var forcedCount = getForcedCount();
    if (forcedCount !== null) {
      state.count = forcedCount;
      state.loaded = true;
      renderCount(forcedCount);
      return;
    }

    if (!window.document) {
      return;
    }

    var collectionPage = isCollectionPage();
    var products = readEmbeddedProducts();

    if (!document.querySelector(BADGE_SELECTOR) && !collectionPage) {
      return;
    }
    applyProducts(products);
  }

  if (window.document) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }

  return {
    BADGE_SELECTOR: BADGE_SELECTOR,
    COLLECTION_HANDLE: COLLECTION_HANDLE,
    DATA_SCRIPT_ID: DATA_SCRIPT_ID,
    DISPLAY_CAP: DISPLAY_CAP,
    STORAGE_KEY: STORAGE_KEY,
    TEST_COUNT_PARAM: TEST_COUNT_PARAM,
    formatBadgeCount: formatBadgeCount,
    getForcedCount: getForcedCount,
    getUnseenCount: getUnseenCount,
    refreshBadges: refreshBadges,
    shouldTrackUrl: shouldTrackUrl
  };
});
